export default "__VITE_ASSET__UAg_4tNa__"